import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export const NarrativeCardCompactSyntheticLayout = ({
  children,
  ...props
}: Props) => {
  return (
    <div className="@container" {...props}>
      <div className="grid grid-cols-2 items-center gap-x2 overflow-hidden rounded-x1_5 bg-surface-2 p-x2 @7xl:grid-cols-[max-content_auto_max-content_1fr] @7xl:p-x3">
        {children}
      </div>
    </div>
  );
};
